module.exports = __webpack_public_path__ + "img/img-6.a1d1b578.png";